import React from "react";
import "./style.css";
import ErrorImage from "../../assets/img/403.png";
import { Button } from "antd";
import signOut from "helpers/signOut";

const Error500 = ({ location }) => {
  return (
    <div className="error-container">
      <div className="error-content">
        <img src={ErrorImage} alt="Not Found" width="250" height="250" />
        <p className="error-header">Oops!</p>
        <p className="error-type">500 - INTERNAL SERVER ERROR</p>
        <p className="error-desc">
          Mohon maaf, terjadi kesalahan saat memproses data.
          <br />
          {location.state ? location.state.errorMessage : ""}
        </p>
        <Button type="primary" size="large" onClick={() => signOut("")}>
          LOGOUT
        </Button>
      </div>
    </div>
  );
};

export default Error500;
